export default __webpack_public_path__ + "static/media/tutorial5-4.61e0c7ed.png";